import { Skeleton } from '@mui/material'
import styled from '@emotion/styled'

interface Props {
   className?: string
}

const SkeletonCard: React.FC<Props> = ({ className }) => {
   return (
      <Holder className={className}>
         <Skeleton variant="text" className="skeleton-card-title" />
         <Skeleton variant="circular" className="skeleton-card-icon" />
         <Skeleton variant="rounded" className="skeleton-card-content" />
         <span className="skeleton-card-line" />
         <Skeleton variant="text" className="skeleton-card-link" />
      </Holder>
   )
}

const Holder = styled.div`
   position: relative;
   font-size: 0.7em;
   display: grid;
   grid-template-rows: 3em auto 5em;
   gap: 1.4em 1em;
   padding: 1.5em 2em;
   border-radius: 1em;
   border: 1px solid #e0e0e0;
   background-color: #fff;
   width: 100%;
   max-width: 42em;
   container-type: inline-size;
   box-sizing: border-box;

   .skeleton-card-title {
      grid-column: 1 / 2;
      max-width: 11em;
      height: 2.3em;
      width: 70%;
   }
   .skeleton-card-icon {
      grid-column: 2 / 3;
      grid-row: 1 / 3;
      align-self: center;
      justify-self: flex-end;
      width: 25cqi;
      height: 25cqi;
      max-width: 5em;
      max-height: 5em;
      aspect-ratio: 1 / 1;
      box-sizing: border-box;

      @container (width < 300px) {
         display: none;
      }
   }

   .skeleton-card-content {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      width: 100%;
      max-width: 18em;
      height: 5em;
   }
   .skeleton-card-link {
      grid-row: 3 / 4;
      margin-top: 2.2em;
      width: 7em;
      height: 1.5em;
   }
   .skeleton-card-line {
      position: absolute;
      display: block;
      bottom: 3.6em;
      height: 1px;
      width: 100%;
      background-color: #e0e0e0;
   }
`

export default SkeletonCard
